import React from 'react';
import Dropzone from 'react-dropzone';
import {CloudDownloadOutlined as CloudIcon} from '@material-ui/icons';
import {FormControl, Input, Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import {FormGroup, FormHelperText, InputLabel} from '@material-ui/core';
import {isEmpty} from 'lodash/lang';
import {formShape} from 'rc-form';


export default function FileUpload(props) {
    const {
        name,
        label,
        rules,
        initialValue,
        form: {getFieldProps, getFieldError},
        helpText,
        ...restProps
    } = props;
    const errors = getFieldError(name);
    const hasError = !isEmpty(getFieldError(name));

    const dropZoneChange = (event) => {
        const {onChange} = props;
        if (onChange) {
            onChange(event);
        }
    };

    const dropZoneElement = () => (
        <div className="quizscape-dropzone">
            <Dropzone onDrop={file => dropZoneChange(file)}>
                {({getRootProps, getInputProps}) => (
                    <section>
                        <div {...getRootProps()}>
                            <input {...getInputProps()} />
                            <CloudIcon fontSize="large"/>
                            <Typography>Drag-and-drop or click to select files to upload.</Typography>
                        </div>
                    </section>
                )}
            </Dropzone>
        </div>
    );

    return (
        <FormGroup className="mui-form-group">
            <FormControl error={hasError}>
                <InputLabel htmlFor={`${name}-button`} shrink>{label}</InputLabel>
                <Input
                    id={name}
                    name={name}
                    label={label}
                    disableUnderline={true}
                    inputComponent={dropZoneElement}
                    inputProps={{
                        ...restProps,
                        ...getFieldProps(name, {
                            validate: [
                                {trigger: 'onChange', rules},
                            ],
                            initialValue,
                        }),
                    }}
                    error={hasError}
                />
                {helpText && <FormHelperText error={false}>{helpText}</FormHelperText>}
                {hasError && errors.map((error, index) =>
                    <FormHelperText key={`file-upload-field-error-${index}`} error={true}>
                        {error}
                    </FormHelperText>)}
            </FormControl>
        </FormGroup>
    );
}

FileUpload.propTypes = {
    form: formShape.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    rules: PropTypes.array.isRequired,
    initialValue: PropTypes.array,
    helpText: PropTypes.string.isRequired
};

FileUpload.defaultProps = {
    rules: [],
    initialValue: [],
    helpText: '',
};
